import React, { useMemo } from "react";
import { palette } from "lib/chartTheme";
import DistributionPie from "./DistributionPie";

const COLORS = [palette.deep, palette.sage];

const GenderDistributionChart = ({ data }) => {
  const slices = useMemo(
    () => [
      { label: "Male", value: data?.male },
      { label: "Female", value: data?.female },
    ],
    [data]
  );
  return <DistributionPie slices={slices} colors={COLORS} emptyText="No gender data yet" />;
};

export default GenderDistributionChart;
